import { Card, CardContent, CardMedia, Typography } from '@mui/material';

const styles = {
  subtitle: {
    fontSize: 14,
    opacity: 0.75,
  },
};

const mediaStyle = {
  width: "100%",
  height: "200px",
  backgroundSize: "contain",
};

const Front = props => {
  const {
    data = {},
    name: nameKey = "name",
    image: imageKey = "image",
    color: colorKey = "color",
    sub: subKey = "sub",
  } = props;

  const title = data[nameKey];
  const image = data[imageKey];
  const color = data[colorKey];
  const subTitle = data[subKey];

  return (
    <Card className="card front">
      <CardMedia
        component="div"
        image={`/${image.src}`}
        alt={title}
        sx={{ ...mediaStyle, backgroundColor: color }}
      />
      <CardContent>
        <Typography sx={styles.subtitle} gutterBottom>
          {subTitle}
        </Typography>
        <Typography noWrap>{title}</Typography>
      </CardContent>
    </Card>
  );
};

export default Front;
